__turbopack_context__.v({
  "footerAnchor": "FooterLink-module-scss-module__NbuvWG__footerAnchor",
  "footerListItem": "FooterLink-module-scss-module__NbuvWG__footerListItem",
});
